import React from 'react'
import { intl } from 'lang/intl'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'

import {
  Button as ButtonComponent,
  BadgeComponent,
} from '../../../../components'
import useFeatures from '../../../../hooks/useFeatures'

import './WebinarPresenterSidebarActionButtonsComponent.scss'

interface WebinarPresenterSidebarActionButtonsComponentProps {
  accentColor: string
  onActivityClick: (event: React.MouseEvent<HTMLElement>) => void
  onQuestionsClick: (event: React.MouseEvent<HTMLElement>) => void
  unreadChatCount: number
  unreadQuestionsCount: number
  currentlySelectedSecondaryPanel?: 'questions'
}

const WebinarPresenterSidebarActionButtonsComponent = ({
  accentColor,
  onActivityClick,
  onQuestionsClick,
  unreadChatCount,
  unreadQuestionsCount,
  currentlySelectedSecondaryPanel,
}: WebinarPresenterSidebarActionButtonsComponentProps) => {
  const { HasWebinarSpeakerQuestions } = useFeatures()

  if (!HasWebinarSpeakerQuestions) return null

  const chatButtonLabel = intl.formatMessage({ defaultMessage: 'Chat' })

  return (
    <div className="webinar-presenter-sidebar-action-buttons-component">
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel': !currentlySelectedSecondaryPanel,
        })}
      >
        <BadgeComponent
          // @ts-expect-error - className is needed as it affects the styling
          className="badge"
          color={accentColor}
          count={unreadChatCount}
        >
          <ButtonComponent
            onClick={onActivityClick}
            color="transparent"
            className="action-button activity"
            ariaLabel={chatButtonLabel}
            size="small"
            data-active
          >
            {chatButtonLabel}
          </ButtonComponent>
        </BadgeComponent>
      </div>
      <div
        className={classnames('button-wrapper', {
          'selected-secondary-panel':
            currentlySelectedSecondaryPanel === 'questions',
        })}
      >
        <BadgeComponent
          // @ts-expect-error - className is needed as it affects the styling
          className="badge"
          color={accentColor}
          count={unreadQuestionsCount}
        >
          <ButtonComponent
            onClick={onQuestionsClick}
            color="transparent"
            className="action-button"
            size="small"
          >
            <FormattedMessage defaultMessage="Questions" />
          </ButtonComponent>
        </BadgeComponent>
      </div>
    </div>
  )
}

export { WebinarPresenterSidebarActionButtonsComponent }
